module.exports = __webpack_public_path__ + "img/33.701b5569.gif";